module.exports = __webpack_public_path__ + "static/media/MacPortrait2w300@1x.b6b37edb.jpg";